<template>
  <div>
    <vs-card class="cstm_vx_card">
      <div class="flex flex-wrap justify-between items-center" slot="header">
        <h4>Holiday</h4>
        <vs-tooltip text="Add" color="primary">
          <vs-button
            v-if="checkEditPermission() && havePermission"
            type="border"
            color="primary"
            icon="add"
            @click="addpopup = true"
          />
        </vs-tooltip>
      </div>
      <div class="vx-row">
        <vs-table :data="holidayProps" class="cstm_vuexy_table w-full">
          <template slot="thead">
            <vs-th sort-key="index">Index</vs-th>
            <vs-th sort-key="index">Holiday Name</vs-th>
            <vs-th sort-key="index">Number of Days</vs-th>
            <vs-th sort-key="index">Holiday Type</vs-th>
            <vs-th sort-key="datefrom">From</vs-th>
            <vs-th sort-key="dateto">To</vs-th>
            <vs-th sort-key="status" style="width: 250px">Action</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :key="indextr" v-for="(item, indextr) in data">
              <vs-td :data="data[indextr].indextr">
                {{ indextr + 1 }}
              </vs-td>
              <vs-td :data="data[indextr].holiday_name">
                {{ data[indextr].holiday_name }}
              </vs-td>
              <vs-td :data="data[indextr].no_of_days">
                {{ data[indextr].no_of_days }}
              </vs-td>
              <vs-td :data="data[indextr]">
                {{
                  data[indextr].can_edit ? "Personal Holiday" : "School Holiday"
                }}
              </vs-td>
              <vs-td :data="data[indextr].start_hour">
                {{ data[indextr].start_hour }}
              </vs-td>
              <vs-td :data="data[indextr].end_hour">
                {{ data[indextr].end_hour }}
              </vs-td>
              <vs-td :data="data[indextr]">
                <vs-row vs-type="flex">
                  <vs-dropdown>
                    <vs-button
                      class="btn-drop"
                      type="flat"
                      icon="more_vert"
                    ></vs-button>
                    <vs-dropdown-menu>
                      <vs-dropdown-item
                        v-if="checkEditPermission"
                        :disabled="
                          data[indextr].can_edit == false || !havePermission
                        "
                        @click="handleedit(data[indextr], indextr)"
                      >
                        Edit
                      </vs-dropdown-item>
                      <vs-dropdown-item
                        v-if="checkDeletePermission()"
                        :disabled="data[indextr].can_edit == false || !havePermission"
                        @click="remove(data[indextr])"
                      >
                        Delete
                      </vs-dropdown-item>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </vs-row>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vs-card>

    <vs-popup
      classContent="popup-example"
      title="Delete"
      :active.sync="deletepopup"
    >
      <h4>Are you sure to delete this ?</h4>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click="handleDelete">Confirm</vs-button>
        <vs-button type="border" color="danger" @click="deletepopup = false"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>

    <vs-popup
      classContent="popup-example"
      title="Add Holiday"
      :active.sync="addpopup"
    >
      <form data-vv-scope="add">
        <label class="custom_Input"
          >Holiday Name<span class="required"></span
        ></label>
        <vs-input
          class="custom_Input w-full"
          v-model="holiday.holiday_name"
          data-vv-name="Holiday Name"
          v-validate="'required'"
        ></vs-input>
        <div
          v-if="errors.has('add.Holiday Name')"
          style="color: red"
          class="invalid-feedback"
        >
          {{ errors.first("add.Holiday Name") }}
        </div>
        <label class="custom_Input"
          >Start Date<span class="required"></span></label
        ><flat-pickr
          class="w-full my-1"
          icon-pack="feather"
          v-validate="'required'"
          icon="icon-calendar"
          icon-after
          data-vv-name="start date"
          v-model="holiday.start_hour"
          :config="startConfigdateTimePicker"
        />
        <span v-show="errors.has('add.start date')" class="text-danger">{{
          errors.first("add.start date")
        }}</span>
        <label class="custom_Input"
          >End Date<span class="required"></span></label
        ><flat-pickr
          v-validate="'required'"
          class="w-full my-1"
          icon-pack="feather"
          icon="icon-calendar"
          icon-after
          data-vv-name="end date"
          v-model="holiday.end_hour"
          :disabled="holiday.start_hour == null"
          :config="{
            dateFormat: 'Y-m-d',
            altInput: true,
            altFormat: 'j F, Y',
            disable: [],
            minDate: holiday.start_hour,
          }"
        />
        <span v-show="errors.has('add.end date')" class="text-danger">{{
          errors.first("add.end date")
        }}</span>
        <div v-if="this.holiday.end_hour != null && this.holiday.end_hour !=''">
          No of days: {{ holiday.no_of_days }}
        </div>
      </form>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click.prevent="handleSave">Save</vs-button>
        <vs-button type="border" color="danger" @click="addpopup = false"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>

    <vs-popup
      classContent="popup-example"
      title="Edit Holiday"
      :active.sync="editpopup"
    >
      <form data-vv-scope="edit">
        <label class="custom_Input"
          >Holiday Name<span class="required"></span
        ></label>
        <vs-input
          class="custom_Input w-full"
          v-model="edit.holiday_name"
          data-vv-name="Holiday Name"
          v-validate="'required'"
        ></vs-input>
        <div
          v-if="errors.has('edit.Holiday Name')"
          style="color: red"
          class="invalid-feedback"
        >
          {{ errors.first("edit.Holiday Name") }}
        </div>
        <label class="custom_Input"
          >Start Date<span class="required"></span></label
        ><flat-pickr
          class="w-full my-1"
          icon-pack="feather"
          v-validate="'required'"
          icon="icon-calendar"
          icon-after
          data-vv-name="start date"
          v-model="edit.start_hour"
          name="startTime"
          :config="{
            dateFormat: 'Y-m-d',
            altInput: true,
            altFormat: 'j F, Y',
            minDate:edit.start_hour
          }"
        />
        <span v-show="errors.has('edit.start date')" class="text-danger">{{
          errors.first("edit.start date")
        }}</span>
        <label class="custom_Input"
          >End Date<span class="required"></span></label
        ><flat-pickr
          v-validate="'required'"
          class="w-full my-1"
          icon-pack="feather"
          icon="icon-calendar"
          icon-after
          data-vv-name="end date"
          name="endtime"
          v-model="edit.end_hour"
          :config="{
            dateFormat: 'Y-m-d',
            altInput: true,
            altFormat: 'j F, Y',
            disable: [],
            minDate: edit.start_hour,
          }"
        />
        <span v-show="errors.has('edit.end date')" class="text-danger">{{
          errors.first("edit.end date")
        }}</span>
        <div v-if="this.edit.end_hour != null">
          No of days: {{ edit.no_of_days }}
        </div>
      </form>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click.prevent="handleUpdate">Save</vs-button>
        <vs-button type="border" color="danger" @click="editpopup = false"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>
  </div>
</template>
<script>
import moment from 'moment'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { TeacherUpdate } from '@/api/teacher'
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'

export default {
  name: 'email',
  components: {
    flatPickr,
    vSelect
  },
  created () {
    const role_permission = localStorage.getItem('role_permission')
    if (role_permission == 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission('Teachers')
    }
  },
  mixins: [PermissionMiddleware],
  props: {
    holidayProps: {
      required: true,
      type: Array,
      default: () => []
    },
    havePermission: {
      default: false
    }
  },
  data () {
    return {
      dateToDay: null,
      addpopup: false,
      deletepopup: false,
      editpopup: false,
      holiday: {
        start_hour: null,
        end_hour: null,
        holiday_name: null,
        no_of_days: 0,
        id: null
      },
      edit: {},
      // edit: {
      //   start_hour: null,
      //   end_hour: null,
      //   holiday_name : null,
      //   no_of_days:0,
      //   id:null
      // },
      editIndex: null,
      deleteindex: null,
      startConfigdateTimePicker: {
        //enableTime: true,
        dateFormat: 'Y-m-d',
        minDate: 'today',
        altInput: true,
        altFormat: 'j F, Y',
        disable: []
      },
      endConfigdateTimePicker: {
        // enableTime: true,
        dateFormat: 'Y-m-d',
        altInput: true,
        altFormat: 'j F, Y',
        disable: []
        //minDate:this.holiday.start_hour
      },
      disabledEndHour: true,
      // configdateTimePicker: {
      //   enableTime: true,
      //   dateFormat: 'Y-m-d H:i:ss'
      // },
      endConfigdateTimePickerEdit: {
        altInput: true,
        altFormat: 'j F, Y',
        dateFormat: 'Y-m-d',
        disable: []
      },
      stratConfigdateTimePickerEdit: {
        altInput: true,
        altFormat: 'j F, Y',
        dateFormat: 'Y-m-d',
        disable: []
        //minDate:new Date()
      },
      holidayAvailability: []
    }
  },
  watch: {
    holidayProps: {
      deep: true,
      immediate: true,
      handler () {
        this.holidayAvailability = this._.cloneDeep(
          this.holidayProps.filter((element) => element.can_edit == true)
        )
      }
    },
    holiday: {
      deep: true,
      handler () {
        if (this.holiday.end_hour) {
          const a = moment(this.holiday.end_hour)
          const b = moment(this.holiday.start_hour)
          const c = a.diff(b, 'days')
          this.holiday.no_of_days = c + 1
        }
        if (this.holiday.start_hour) {
          this.disabledEndHour = false
          const today = new Date(this.holiday.start_hour)
          const startDate = `${today.getFullYear()}-${
            today.getMonth() + 1
          }-${today.getDate()}`

          const __temp = {
            from: '1000-01-01',
            to: startDate
          }
          this.endConfigdateTimePicker.disable.push(__temp)
        }
      }
    },
    edit: {
      deep: true,
      handler () {
        if (this.edit.end_hour) {
          const a = moment(this.edit.end_hour)
          const b = moment(this.edit.start_hour)
          const c = a.diff(b, 'days')
          this.edit.no_of_days = c + 1
        }
        if (this.edit.start_hour) {
          this.disabledEndHour = false
          const today = new Date(this.edit.start_hour)
          const startDate = `${today.getFullYear()}-${
            today.getMonth() + 1
          }-${today.getDate()}`
          const __temp = {
            from: '1000-01-01',
            to: startDate
          }
          this.endConfigdateTimePickerEdit.disable.push(__temp)
        }
      }
    }
  },
  /* computed: {
    holidayAvailability: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    header () {
      return `Holidays (${this.holidayAvailability.length})`
    }
  }, */
  methods: {
    handlePhonedefault (index) {
      this.holidayAvailability.map((item) => {
        item.default = 0
      })
      this.holidayAvailability[index].default = 1
    },
    handleSave () {
      this.$validator.validateAll('add').then((result) => {
        if (result) {
          const payload = this.holiday
          const d = new Date(payload.start_hour)
          const _temp = {
            no_of_days: payload.no_of_days,
            holiday_name: payload.holiday_name,
            end_hour: payload.end_hour,
            start_hour: payload.start_hour,
            id: null
          }
          this.holidayAvailability.push(_temp)

          console.log('hii from save')
          this.handleHolidaysave()
        } else {
          this.showSuccessMessage('Error', 'Validation is Required', 'danger')
        }
      })
    },
    handleedit (data, index) {
      console.log(data)
      // return false

      this.edit = data
      console.log(this.edit)
      this.editIndex = index
      this.editpopup = true

    },
    handleUpdate () {
      this.$validator.validateAll('edit').then((result) => {
        if (result) {
          const payload = this.edit
          //const d = new Date(payload.start_hour)
          if (this.isValid(payload.start_hour, payload.end_hour)) {
            const _temp = {
              no_of_days: payload.no_of_days,
              holiday_name: payload.holiday_name,
              end_hour: payload.end_hour,
              start_hour: payload.start_hour,
              id: payload.id
            }

            console.log(_temp)
            this.holidayAvailability[this.editIndex] = _temp

            //this.holidayAvailability =  this.holidayAvailability.filter(element => element.can_edit == true)
            console.log(this.holidayAvailability)
            this.handleHolidaysave()
          }
        } else {
          this.showSuccessMessage('Error', 'Validation is Required', 'danger')
        }
      })
    },
    handleDelete () {
      console.log(this.deleteindex)
      this.deleteindex = this.holidayAvailability.findIndex(
        (ele) => ele.id == this.deleteindex
      )
      this.holidayAvailability.splice(this.deleteindex, 1)
      this.handleHolidaysave()
    },
    remove (index) {
      this.deletepopup = true
      this.deleteindex = index.id
    },
    isValid (start, end) {
      const startDate = new Date(start)
      const endDate = new Date(end)
      if (startDate < endDate) {
        return true
      } else {
        // this.preventIsvalid = true
        this.$vs.notify({
          title: 'Warning',
          text: 'End time must be gretter then start time',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }
    },
    async handleHolidaysave () {
      this.holidayAvailability = this.holidayAvailability.map((element) => {
        delete element.can_edit
        return element
      })
      console.log(this.holidayAvailability)
      try {
        const customer_id = localStorage.getItem('customer_id')
        const payload = {
          updateField: {
            holidays: this.holidayAvailability
          }
        }
        const { data } = await TeacherUpdate(
          payload,
          this.$route.params.teacher_id,
          customer_id
        )
        this.$validator.reset()


        this.addpopup = false
        this.editpopup = false
        this.deletepopup = false

        this.holiday = {
          start_hour: null,
          end_hour: null,
          holiday_name: '',
          no_of_days: null,
          id: null
        }
        this.$emit('setAfterUpdate', data)

        this.showSuccessMessage('Success', 'Updated Successfully', 'success')
      } catch (error) {
        console.log(error)
        this.showSuccessMessage('Error', error.data.message, 'danger')
      }
    }
  }
}
</script>
<style scoped>
.required:after {
  content: " *";
  color: red;
}
</style>
